import { Injectable } from '@angular/core';
import { DialogMessage, HistoryItemResponse } from '@shared/index';
import { BotService } from './bot.service';
import { MessageManagerAdminService } from './message-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';

@Injectable({
  providedIn: 'root'
})
export class DialogStoreManagerService {

  constructor(
    private botService: BotService,
    private messageMgr: MessageManagerAdminService,
    private botidService: BotidService
  ) { }

  public async getCurrentDialog() {
    const botId = this.botidService.getBotId();
    return (await this.botService.getHistoryMessages(botId)).messageHistory;
  }

  public async storeDialogToLocalStorage(key: string) {
    const id = key ? key : "dialog_" + new Date().getTime() + "_" + Math.random() * 10000;
    localStorage.setItem(id, JSON.stringify(await this.getCurrentDialog()));
    return id;
  }
  // removeExisting: if true, all messages in the current dialog will be deleted, before restoring
  // ignoreExisting: if true, messages that are already in the dialog will not be restored
  public async restoreDialogFromLocalStorage(dialogId: string, removeExisting: boolean = false, ignoreExisting: boolean = true) {
    if (removeExisting) {
      const dialog = await this.getCurrentDialog();
      const botId = this.botidService.getBotId();
      if (botId && dialog.length > 0) {
        await this.botService.deleteHistoryMessages(botId, dialog.map(m => m._id));
      }
    }
    const str = localStorage.getItem(dialogId);
    if (str == null) {
      console.warn("No Dialog to restore found with id " + dialogId);
      return null;
    }
    const historyItems: HistoryItemResponse[] = JSON.parse(str) as HistoryItemResponse[];
    const addedHistoryItems = await this.addDialogMessagesFromHistoryItems(historyItems, ignoreExisting);
    return addedHistoryItems;
  }
  public createDialogMessageFromHistoryItem(item: HistoryItemResponse): DialogMessage {
    return {
      content: item.content,
      role: item.role,
      bypass: item.bypass
    };
  }
  public async addDialogMessagesFromHistoryItems(historyItems: HistoryItemResponse[], ignoreExisting: boolean) {
    if (ignoreExisting) {
      const currentHistoryItems = await this.getCurrentDialog();
      const currentIds = currentHistoryItems.map(m => m._id);
      historyItems = historyItems.filter(m => !currentIds.includes(m._id));
    }
    const messages = historyItems.map(item => this.createDialogMessageFromHistoryItem(item));
    return await this.messageMgr._addMessagesToThread(messages);
  }
  public async overrideDialogFromLocalStorage(dialogId: string) {
    return await this.restoreDialogFromLocalStorage(dialogId, true, false);
  }

  public async appendDialogFromLocalStorage(dialogId: string) {
    return await this.restoreDialogFromLocalStorage(dialogId, false, true);
  }
  public async appendDialogFromLocalStorageIgnoreExisting(dialogId: string) {
    return await this.restoreDialogFromLocalStorage(dialogId, false, false);
  }
}
